import { FC, ReactNode } from "react";

import Flogo from "../../assets/logo2.png";
// import Flogo from "@funded-here-interface/common/src/assets/synlian_logo.png";
import BackImage from "../../assets/sideBackground.svg";
import { useStyles } from "./AcknowledgementLayout.styles";

interface IProps {
  content: ReactNode;
  showLogo?: boolean;
}

const AcknowledgementLayout: FC<IProps> = ({ content, showLogo = true }) => {
  const { classes } = useStyles();

  return (
    <div className={classes.container}>
      {showLogo && (
        <div className={classes.iconContainer}>
          <img className={classes.logo} src={Flogo} alt="" />
        </div>
      )}
      <div className={classes.leftContainer}>
        <div className={classes.pageContainer}>
          <div className={classes.stepContent}>{content}</div>
        </div>
      </div>
      <div className={classes.backImage}>
        <img src={BackImage} alt="" />
      </div>
    </div>
  );
};

export default AcknowledgementLayout;
